// ** React Imports
import React from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import Text from "components/typography/Text";
import LinkNative from "components/layout/LinkNative";

const Links = ({ user }) => {
	const { t } = useTranslation(["pages"]);

	// #####################################################

	if (user?.listOfLinksArray?.length === 0) {
		return null;
	}

	return (
		<>
			<Block pt={!user.descriptionObject?.plain ? 0 : 6}>
				<Text bold size="1.25rem">
					{t("pages:userpanelDataLinks")}
				</Text>
			</Block>
			<Block>
				{user.listOfLinksArray?.map((item, index) => {
					return (
						<Block key={`block-link-profile-${index}`}>
							{item.typ === 1 && "Instagram: "}
							{item.typ === 2 && "Pornhub: "}
							{item.typ === 3 && "Onlyfans: "}
							<LinkNative
								href={item.link}
								key={`link-profile-${index}`}
								color="primary"
								target="_blank"
								underline
								style={{ wordBreak: "break-all" }}
							>
								{item.link}
							</LinkNative>
						</Block>
					);
				})}
			</Block>
		</>
	);
};

export default Links;
